import { useCallback } from 'react';
import { Box } from '@alf/uikit';
import { LOG_ACTIONS, useLogAmplitude } from '@namespace/analytics';
import { useConfig, useGeneralRoutes } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';
import { FavoritesLink } from '../../../common';
import { CyberSportBaseMenuList } from '../../../common/BaseMenuList/CyberSportBaseMenuList';
import { MODE } from '../../../constants';
import { useCyberSportGetPathParams } from '../../../hooks/useCyberSportGetPathParams';
import { MenuHeader } from './components/MenuHeader';
import ListAllItem from './ListAllItem';

import styles from './index.module.css';

// actual: categories, displayed as: sports
const CyberSportMenuList = ({ id }) => {
  const { t } = useI18n();
  const {
    cyberSport,
    cyberSportCategory,
    cyberSportTournament,
    cyberSportFavorites
  } = useGeneralRoutes();

  const { config } = useConfig(id);
  const { showCategories = false } = config;

  const { category, activeSport, tournament } = useCyberSportGetPathParams();
  const { categoryId: activeCategoryId } = category || {};
  const { sportId } = activeSport || {};
  const { tournamentId, categoryId: tournamentCategoryId } = tournament || {};
  const logAmplitude = useLogAmplitude();

  const handleItemClick = useCallback(
    ({ name }) => {
      logAmplitude({
        actionName: LOG_ACTIONS.SPORTS_BOOK_CYBERSPORT_OPEN,
        attributes: {
          cybersport_name: name,
          entry_point: 'cybersports_list'
        }
      });
    },
    [logAmplitude]
  );

  return (
    <Box
      data-role="cyber-sport-menu-list"
      direction="column"
      className={styles.cyberSportMenuWrapper}
    >
      <MenuHeader
        title="cybersport"
        hideAdvFilter={true}
        classNames={{
          headerClassName: styles.menuHeaderPreMatch
        }}
        dataRole="cyber-sport"
      />
      <ListAllItem
        isActive={!activeCategoryId}
        route={cyberSport}
        serviceIds={[MODE.PRE_MATCH, MODE.IN_PLAY]}
        sportId={sportId}
        title={t('sportsBook.menu.allCyberSport')}
        classNames={{ itemClass: styles.itemAll }}
        withIcons={true}
        dataRole="cybersport-list"
        onClick={() => handleItemClick({ name: 'all' })}
      />
      <FavoritesLink
        to={cyberSportFavorites}
        title={t('sportsbook.menu.cyberSportFavorites')}
        className={styles.favoriteItem}
        onClick={() => handleItemClick({ name: 'favorites' })}
      />
      <CyberSportBaseMenuList
        tournamentId={tournamentId}
        activeSportId={activeCategoryId}
        basePath={cyberSportCategory}
        categoryRoute={cyberSportTournament}
        showCategories={showCategories}
        categorySportId={tournamentCategoryId}
        categoriesWithIcon={false}
        showPinIcon={true}
      />
    </Box>
  );
};

export default CyberSportMenuList;
